module.exports = __webpack_public_path__ + "img/4.890cd8c8.jpg";